<div class="bg-secsel">
  <div class="container">
    <div class="row align-items-center justify-content-center min-vh-100 gx-0">
      <div class="col-12 col-md-5 col-lg-4">
        <div class="py-10 d-flex align-items-center justify-content-center">
          <img src="/assets/icons/Logo.svg" alt="Logo here" class="me-4 rounded-2 shadow">
          <h1 class="p-0 m-0">Expert Chat</h1>
        </div>
        <div class="col-12 alert alert-{{messageType}} d-flex justify-content-between align-items-center fs-6" role="alert" *ngIf="messageText">
          {{messageText}} <i class="btn-close p-2 alert-close" (click)="closeAlert()"></i>
        </div>
        <div class="card card-shadow border-0" [formGroup]="loginForm">
          <div class="card-body">
            <div class="row g-6">
              <div class="col-12">
                <div class="text-center">
                  <h3 class="fw-bold mb-2">Forgot your password?</h3>
                </div>
              </div>

              <div class="col-12">
                <input
                  type="email"
                  class="form-control"
                  id="signin-email"
                  placeholder="Email"
                  (input)="toLowerCase()"
                  formControlName="email">
                <small
                  class="text-danger"
                  *ngIf="loginForm.controls.email.errors?.pattern"
                >
                  Email address is invalid
                </small>
                <small
                  class="text-danger"
                  *ngIf="loginForm.controls.email.errors?.required"
                >
                  Email address is required
                </small>
              </div>

              <div class="col-12">
                <button
                  class="btn btn-outline app-btn-yellow w-100"
                  [class.disabled]="this.loginForm.controls.email.errors?.pattern || this.loginForm.controls.email.errors?.required"
                  type="button"
                  (click)="restorePassword()">
                  Restore
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> <!-- / .row -->
  </div>
</div>
